<template>
    <layout>
        <div class="publicLayout__form-card">
            <header class="publicLayout__form-header">
                <h2 class="publicLayout__form-title">Busca tus requerimientos a pagar</h2>
                <p class="publicLayout__form-subtitle">Ingresa tu DPI o NIT para consultar tus pólizas</p>
            </header>

            <div class="publicLayout__field">
                <label class="publicLayout__label" for="public-search-type">Buscar por</label>
                <select id="public-search-type" v-model="typesearch" class="form-control publicLayout__input">
                    <option value="dpi">DPI</option>
                    <option value="nit">NIT</option>
                </select>
            </div>

            <div class="publicLayout__field" v-if="typesearch === 'dpi'">
                <label class="publicLayout__label" for="public-search-value">Número de DPI</label>
                <p class="publicLayout__hint">Sin guiones ni espacios</p>
                <input
                    id="public-search-value"
                    type="tel"
                    class="form-control publicLayout__input"
                    placeholder="Ej. 1234567890101"
                    v-model="searchValue"
                    v-on:keyup.enter="preSearch"
                >
            </div>

            <div class="publicLayout__field" v-if="typesearch === 'nit'">
                <label class="publicLayout__label" for="public-search-nit">Número de NIT</label>
                <p class="publicLayout__hint">Incluyendo el guión</p>
                <input
                    id="public-search-nit"
                    type="text"
                    class="form-control publicLayout__input"
                    placeholder="Ej. 1234567-8"
                    v-model="searchValue"
                    v-on:keyup.enter="preSearch"
                >
            </div>

            <div class="publicLayout__form-actions">
                <button @click="preSearch" type="button" class="btn btn-primary btn__buscar publicLayout__btn-submit" :disabled="procesando">
                    <span v-if="procesando">Buscando...</span>
                    <span v-else>Buscar</span>
                </button>
            </div>
        </div>

        <div class="publicLayout__results" v-if="searched || Object.keys(polizas).length > 0">
            <h3 class="publicLayout__results-title" v-if="Object.keys(polizas).length > 0">Pólizas encontradas</h3>
            <div class="searchResult">
                <div class="row m-0" v-if="Object.keys(polizas).length > 0">
                    <template v-if="(typesearch === 'nit' || typesearch === 'dpi')">
                        <div v-for="poliza in polizas" :key="poliza.llave_poliza || poliza.poliza" class="col-12 publicLayout__result-item resultItem">
                            <div class="publicLayout__result-product font-weight-bold">
                                {{ poliza.descripcion_producto }} — {{ poliza.estado_poliza }}
                            </div>
                            <div v-if="poliza.datos_particulares !== '/'" class="font-weight-bold text-muted small">
                                {{ poliza.datos_particulares }}
                            </div>
                            <div class="publicLayout__result-name">
                                {{ poliza.asegurado }}
                            </div>
                            <div class="searchResultBadges mt-2">
                                <div class="miniInfo">
                                    <span>Póliza:</span>
                                    <strong>{{ poliza.poliza }}</strong>
                                </div>
                                <div class="miniInfo">
                                    <span>Vigencia:</span>
                                    {{ dayjs(poliza.inicio_vigencia).format('DD-MM-YYYY') }} al {{ dayjs(poliza.fin_vigencia).format('DD-MM-YYYY') }}
                                </div>
                            </div>
                            <div class="publicLayout__result-actions">
                                <button @click="$router.push('/mis-pagos-rq/' + poliza.llave_poliza + '?poliza=' + poliza.poliza)" class="btn btn__guardar w-100">
                                    <i class="fa fa-eye" aria-hidden="true"></i> Ver detalles
                                </button>
                            </div>
                        </div>
                    </template>
                </div>
                <div v-if="searched && Object.keys(polizas).length === 0" class="publicLayout__empty">
                    No se encontraron pólizas para los datos ingresados.
                </div>
            </div>
        </div>
    </layout>
</template>

<script>

import Layout from "../../global/components/LayoutPublico.vue";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import Pago from "src/modules/pos/views/Pago";
import InicioPago from "src/modules/pos/views/components/InicioPago";
import {requestGuardMixin} from "src/core/requestGuard";

export default {
    mixins: [requestGuardMixin],
    props: {},
    components: {
        Pago,
        Layout,
        InicioPago,
    },
    data() {
        return {
            Valid: {},
            searchExtraUno: "",
            searchExtraDos: "",
            searchValue: "",
            typesearch: "dpi",
            searched: false,
            polizas: {},

            pagar: 0,
            tipoPago: '',
            nit: '',
            nombre: '',
            direccion: '',
            polizaNo: '',

            pagandoref: 0,
            pagosToApply: {}
        };
    },
    mounted() {
        if (!this.tieneParamsRuta()) {
            return;
        }
        this.searchValue = this.$route.params.search;
        this.typesearch = this.$route.params.type;
        this.searchExtraUno = this.$route.params.extra || '';
        this.searchExtraDos = this.$route.params.extrados || '';
        this.search();
    },
    beforeUnmount() {
        this.finalizarProceso();
    },
    methods: {
        Numbro,
        dayjs,
        esBusquedaValida() {
            if (Tools.isEmptyString(this.searchValue)) {
                return false;
            }
            if (this.typesearch === 'dpi' && parseInt(this.searchValue, 10) === 0) {
                return false;
            }
            return this.typesearch === 'dpi' || this.typesearch === 'nit';
        },
        search() {

            const self = this;

            if (!self.esBusquedaValida()) {
                return;
            }

            if (!self.iniciarProceso()) {
                return;
            }

            let url = '';

            if (self.typesearch === 'dpi') {
                url = 'consulta/dpi/publico?s=' + encodeURIComponent(self.searchValue);
            }
            else if (self.typesearch === 'nit') {
                url = 'consulta/nit/publico?s=' + encodeURIComponent(self.searchValue);
            }
            else {
                self.finalizarProceso();
                return;
            }

            API.send('GET', url, null,
                function (response) {
                    if (response.status) {
                        self.polizas = (typeof response.data === "object") ? response.data : {};

                        self.searched = true;
                    }
                    else {
                        self.searched = true;
                        alert(response.msg);
                    }
                    self.finalizarProceso();
                },
                function () {
                    self.searched = true;
                    self.finalizarProceso();
                    alert('Error de conexión, por favor intente de nuevo');
                },
                {disableLoading: true, singleFlight: true})
        },
        preSearch() {

            if (this.procesando) {
                return false;
            }

            if (!this.esBusquedaValida()) {
                return false;
            }

            if (this.typesearch === 'dpi') {
                this.$router.push({path: '/mis-pagos/dpi/' + this.searchValue});
            }
            else if (this.typesearch === 'nit') {
                this.$router.push({path: '/mis-pagos/nit/' + this.searchValue});
            }
            else if (this.typesearch === 'requerimiento') {
                this.$router.push({path: '/mis-pagos/requerimiento/' + this.searchValue + '/' + this.searchExtraUno});
            }
            else if (this.typesearch === 'poliza') {
                this.$router.push({path: '/mis-pagos/poliza/' + this.searchValue + '/' + this.searchExtraUno+ '/' + this.searchExtraDos});
            }
            this.search();
        },
        activarPagandoRef(data) {
            this.pagandoref = data;
        },
        cancelarPago() {
            this.pagar = 0;
        },
        cancelarPagoRefresh() {
            store.dispatch('coreShowLoading');
            location.reload();
        }
    },
};
</script>
